import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/Home.vue";
import Log from "../components/Log.vue";
import Login from "../components/Login.vue";
import LogText from "../components/LogText.vue";
import LogUrination from "../components/LogUrination.vue";
import LogBowelMovement from "../components/LogBowelMovement.vue";
import Contacts from "../components/Contacts.vue";
import Calendar from "../components/Calendar.vue";
import Report from "../components/Report.vue";
import Inventory from "../components/Inventory.vue";
import NotificationSettings from "../components/NotificationSettings.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/log",
    name: "Log",
    component: Log,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/log-text",
    name: "LogText",
    component: LogText,
  },
  {
    path: "/log-urination",
    name: "LogUrination",
    component: LogUrination,
  },
  {
    path: "/log-bm",
    name: "LogBowelMovement",
    component: LogBowelMovement,
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: Contacts,
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: Calendar,
  },
  {
    path: "/reports",
    name: "Report",
    component: Report,
  },
  {
    path: "/inventory",
    name: "Inventory",
    component: Inventory,
  },
  {
    path: "/notification-settings",
    name: "NotificationSettings",
    component: NotificationSettings,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
